import React, {useMemo} from 'react';

import useSearchStore from '../../_Global/SearchStore';
// import ClearFacetsButton from '../../clear-facets-button/jsx/ClearFacetsButton';

interface SortConfiguration {
    label: string;
    selectOptions: {
        label: string;
        value: string;
    }[];
    isActive: boolean;
    onToggle(string): void;
}

interface SortFacetValue {
    label: string;
    value: string;
}

function SortSelection({label, selectOptions, isActive, onToggle}: SortConfiguration) {
    const funnelbackQueryParameters = useSearchStore((state) => state.funnelbackQueryParameters);
    const setFunnelbackQueryParameters = useSearchStore((state) => state.setFunnelbackQueryParameters);
    const setQueueScrollToForm = useSearchStore((state) => state.setQueueScrollToForm);
    const id = useMemo(() => label.replace(/\s/, '-'), []);

    /**
     * Respond to clicks on the accordion button
     */
    const onAccordionClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.preventDefault();

        onToggle(isActive ? '' : label);
    };

    /**
     * Respond to changes to the facet option inputs.
     */
    const onSortOptionChange = (evt: React.MouseEvent<HTMLButtonElement>) => {
        evt.preventDefault();
        const newValue = evt.currentTarget.name;

        setFunnelbackQueryParameters({
            sort: newValue,
        });

        // Scroll to the top of the form
        setQueueScrollToForm(true);
    };

    function generateSortOptions(facetsJson: SortFacetValue[]) {
        return facetsJson.map((option) => {
            let isChecked = false;

            if (funnelbackQueryParameters.sort == option.value) {
                isChecked = true;
            }

            return (
                <button
                    className={`button button--filter ${isChecked ? 'button--active' : ''}`}
                    key={crypto.randomUUID()}
                    onClick={onSortOptionChange}
                    id={option.label}
                    name={option.value}
                >
                    <svg className="button__icon">
                        <use xlinkHref="#tick"></use>
                    </svg>
                    <span className="button__label body-size-sm">{option.label}</span>
                </button>
            );
        });
    }

    return (
        <>
            <div className="search-filter-accordion__controls">
                <button
                    id={`filter-accordion-${id}`}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    aria-controls={`filter-${id}-panel`}
                    className={`button button--tab body-size-xl ${isActive ? 'button--active' : ''}`}
                    aria-expanded={isActive}
                    onClick={onAccordionClick}
                >
                    <div className={`icon__expand-container ${isActive && 'icon__expand--active'}`}>
                        <svg className="icon__expand-horizontal">
                            <use xlinkHref="#minus"></use>
                        </svg>
                        <svg className="icon__expand-vertical">
                            <use xlinkHref="#minus"></use>
                        </svg>
                    </div>
                    <span className="button__label">{label}</span>
                </button>
            </div>

            <div
                id={`filter-${id}-panel`}
                className={`search-filter-tabs__tab-content ${isActive ? 'tab-content--active-accordion' : ''}`}
                role="tabpanel"
                aria-labelledby={`${`filter-tab-${id}`} ${`filter-accordion-${id}`}`}
            >
                <div className="search-filter-tabs__tab-options-wrapper">
                    <div className="search-filter-tabs__tab-options">{generateSortOptions(selectOptions)}</div>
                </div>
            </div>
        </>
    );
}

export default React.memo(SortSelection);
